module.exports = __webpack_public_path__ + "img/icoMypage.9b4c36dd.png";